import { ValidateResult } from '../ux/form/useForm';

export function textValidator(options?: {
  unicodeBMPOnly?: boolean;
  required?: boolean | string | ((values: any) => boolean | string);
  trim?: boolean;
  maxLength?: number;
  regex?: RegExp | { pattern: RegExp; msg: string };
  valid?: (s: string) => ValidateResult;
}) {
  return (s: string | undefined, values?: any): ValidateResult => {
    const required =
      typeof options?.required === 'function'
        ? options?.required(values)
        : options?.required;
    if (options?.trim) {
      s = s?.trim();
    }
    if (!s) {
      return required
        ? {
            type: 'invalid',
            msg:
              typeof required === 'string'
                ? required
                : 'This field is required',
          }
        : { type: 'valid' };
    }

    if (options?.valid) {
      const res = options?.valid(s);
      if (res.type === 'invalid') {
        return res;
      }
    }

    if (options?.regex) {
      const pattern =
        'pattern' in options.regex ? options.regex.pattern : options.regex;
      if (!pattern.test(s)) {
        const msg =
          'pattern' in options.regex ? options.regex.msg : 'Invalid format';
        return { type: 'invalid', msg };
      }
    }

    if (
      options?.unicodeBMPOnly &&
      /(?:[\uD800-\uDBFF][\uDC00-\uDFFF])/.test(s)
    ) {
      // console.log(s);
      return {
        type: 'invalid',
        msg: 'Special characters such as emojis are not allowed',
      };
    }

    if (
      options?.maxLength != null &&
      options?.maxLength > 0 &&
      s.length > options?.maxLength
    ) {
      return {
        type: 'invalid',
        msg: `Only maximum ${options.maxLength} characters are allowed`,
      };
    }

    return { type: 'valid' };
  };
}
